import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {LoginRequest} from "../../../../modules/auth/models/login-request";
import {AuthService} from "../../../../modules/auth/services/auth-service";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {BaseResponse} from "../../../models/base-response";
import {Token} from "../../../../modules/auth/models/token";
import {environment} from "../../../../../environments/environment";

@Component({
    selector: 'app-formulario',
    templateUrl: './formulario.component.html',
    styleUrl: './formulario.component.css',
    standalone: false
})
export class FormularioComponent implements OnInit {
  formLogin: FormGroup;
  request = new LoginRequest();
  mostrarSenha = false;

  constructor(private authService: AuthService,
              private formBuilder: FormBuilder,
              private toastr: ToastrService,
              private router: Router) {
    this.construirFormLogin();
  }

  ngOnInit(): void {
    const savedEmail = localStorage.getItem('rememberedEmail');
    if (savedEmail) {
      this.formLogin.patchValue({
        email: savedEmail,
        lembrarMe: true
      });
    }

    // Preencher credenciais padrão quando não for produção
    if (!environment.isProduction) {
      this.formLogin.patchValue({
        email: 'teste@teste.com.br',
        senha: '123456'
      });
    }
  }

  public toggleMostrarSenha() {
    this.mostrarSenha = !this.mostrarSenha;
  }

  public logar(){
    console.log('Botão logar clicado. Status do formulário:', this.formLogin.status);
    if (this.formLogin.invalid) {
      this.formLogin.markAllAsTouched();
      this.toastr.warning('Por favor, preencha todos os campos corretamente.');
      return;
    }

    this.preencherModelo();
    console.log('Chamando authService.login com:', this.request);
    this.authService.login(this.request).subscribe(
      (response: any) => {
        console.log('Resposta recebida do servidor:', response);
        // Se a resposta for o BaseResponse esperado
        if (response && response.sucesso) {
          this.authService.setAccessToken(response.dados);
          this.toastr.success('Login feito com sucesso');

          this.gerenciarLembrarMe();
          this.redirecionamentoSucesso();
        }
        // Se a resposta for sucesso mas tiver flag de erro ou dados nulos
        else if (response && response.errors && response.errors.length > 0) {
          console.warn('Resposta com erro de negócio:', response.errors);
          this.toastr.error(response.errors[0].mensagem);
        }
        else {
          console.error('Resposta de sucesso inesperada:', response);
          this.toastr.error('Erro ao realizar login. Verifique suas credenciais.');
        }
      },
      (error) => {
        console.error('Erro de login capturado no subscribe:', error);
        let mensagemErro = 'Falha na conexão com o servidor';

        if (error.error) {
          if (error.error.errors && error.error.errors.length > 0) {
            mensagemErro = error.error.errors[0].mensagem;
          } else if (error.error.mensagem) {
            mensagemErro = error.error.mensagem;
          } else if (typeof error.error === 'string' && error.error.length < 100) {
            mensagemErro = error.error;
          }
        } else if (typeof error === 'string') {
          mensagemErro = error;
        }

        this.toastr.error(mensagemErro);
      }
    );
  }

  private gerenciarLembrarMe() {
    const email = this.formLogin.get('email')?.value;
    const lembrar = this.formLogin.get('lembrarMe')?.value;

    if (lembrar) {
      localStorage.setItem('rememberedEmail', email);
    } else {
      localStorage.removeItem('rememberedEmail');
    }
  }

  private preencherModelo(){
    this.request.email = this.formLogin.controls[`email`].value;
    this.request.senha = this.formLogin.controls[`senha`].value;
  }

  private redirecionamentoSucesso() {
    this.router.navigateByUrl('/');
  }

  private construirFormLogin(){
    this.formLogin = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.maxLength(200)]],
      senha: ['', [Validators.required, Validators.maxLength(20)]],
      lembrarMe: [false]
    });
  }
}
